import _ from 'lodash';
import { Heading } from 'tiptap-extensions';
import { setBlockType, toggleBlockType } from 'tiptap-commands';
import { nodeIsActive } from 'tiptap-utils';
import {
  TextFormattingNodeSpec,
  getTextFormattingNodeAttrs,
  getTextFormattingDOM,
} from './TextFormattingNode';

const headingTagMap = {
  H1: 1,
  H2: 2,
  H3: 3,
  H4: 4,
  H5: 5,
  H6: 6,
};

function getAttrs(dom) {
  const attrs = getTextFormattingNodeAttrs(dom);
  const level = headingTagMap[dom.nodeName.toUpperCase()] || 1;
  attrs.level = level;
  return attrs;
}

function toDOM(node) {
  const dom = getTextFormattingDOM(node);
  const level = node.attrs.level || 1;
  dom[0] = `h${level}`;
  return dom;
}

export default class DMHeading extends Heading {
  get schema() {
    return {
      ...TextFormattingNodeSpec,
      attrs: {
        level: { default: 1 },
        ...TextFormattingNodeSpec.attrs,
      },
      defining: true,
      parseDOM: [
        { tag: 'h1', getAttrs },
        { tag: 'h2', getAttrs },
        { tag: 'h3', getAttrs },
        { tag: 'h4', getAttrs },
        { tag: 'h5', getAttrs },
        { tag: 'h6', getAttrs },
      ],
      toDOM,
    };
  }

  commands({ type }) {
    return (attrs) => (state, dispatch, view) => {
      const { selection } = state;
      const position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$to.pos;
      const $pos = state.doc.resolve(position);
      const $parent = $pos.parent;
      const updateAttrs = $parent ? _.clone($parent.attrs) : {};

      Object.assign(updateAttrs, attrs);

      const isActive = nodeIsActive(state, type, attrs);

      if (isActive) {
        return setBlockType(toggleBlockType)(state, dispatch, view);
      }

      return setBlockType(type, updateAttrs)(state, dispatch, view);
    };
  }
}
